import React, { useState } from "react";
import { connect } from "react-redux";
import cleanDeep from "clean-deep";
import { Actions as REPORTACTIONS } from "../../store/actions/reportActions";

import apiURL from "../../store/actions/apiURL";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { DocumentArrowDownIcon } from "@heroicons/react/20/solid";

const ReportBtn = ({
	report,
	startDate,
	endDate,
	enabled,
	checkGroupBy,
	totalsOnly,
	departmentFilter,
	showModalOnPress,
	showReportPayPeriodModal,
}) => {
	const [loading, setLoading] = useState(false);

	const onClick = (e) => {
		if (!enabled) {
			return;
		}

		setLoading(true);

		const qs = new URLSearchParams(
			cleanDeep({
				start: format(startDate, "yyyy-MM-dd"),
				end: format(endDate, "yyyy-MM-dd"),
				group: checkGroupBy,
				totals: totalsOnly,
				department: departmentFilter,
			}),
		);

		if (showModalOnPress) {
			showReportPayPeriodModal(report.id);
			setLoading(false);
			return;
		}

		if (report.method == "s3Link") {
			e.preventDefault();
			e.stopPropagation();

			fetch(`${apiURL}${report.path ? report.path : `/report/get/${report.id}`}?${qs}`, {
				credentials: "include",
				method: "GET",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
					/*'Organisation': getState().currentOrganisation,*/
				},
			})
				.then((response) => response.json())
				.then((data) => {
					const popup = window.open(data.signedURL);
					if (!popup || popup.closed || typeof popup.closed == "undefined") {
						//Worked For IE and Firefox
						alert("Popup Blocker is enabled! Please add this site to your exception list.");
					}
					setLoading(false);
				});
		}
	};

	return (
		<div className="row d-flex justify-content-center">
			<div
				className="col-sm-4"
				key={report.id}
				style={{ margin: "auto", width: "100%" }}
			>
				<a
					href="#"
					className="btn btn-default"
					onClick={onClick}
				>
					{report.company != 0 && (
						<Link
							style={{ float: "right" }}
							target="_blank"
							type="button"
							data-toggle="tooltip"
							title="Edit Report"
							to={"/organisation/reports/template/" + report.id + "/"}
						></Link>
					)}
					<DocumentArrowDownIcon style={{ height: "1.5em", float: "left" }} />
					<div style={{ float: "left", marginLeft: 5 }}>Download Payroll Report</div>
				</a>
			</div>
		</div>
	);
};

const mapStateToProps = () => {};

const mapDispatchToProps = (dispatch) => ({
	showReportPayPeriodModal: (show) => dispatch(REPORTACTIONS.showReportPayPeriodModal(show)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportBtn);
